<ul class="segmented-control" ngClass="{{classes}} {{loading ? 'loading' : ''}}" role="radiogroup" tabindex="0" [attr.aria-label]="ariaLabel">
    <li *ngFor="let option of options" [ngClass]="TAP_optionClasses(option)" skeletonLoader [translationKey]="option.labelKey">
        <button *ngIf="option.tooltip" type="button" 
        [tooltip]="option.tooltip ? option.tooltip : null" 
        [disabled]="(option.disableButton ? option.disableButton : null) || loading"
        (click)="TAP_select(option.value)" 
        [attr.aria-label]="option.label" 
        role="radio" 
        [attr.aria-checked]="option.value === this.value" 
        tabindex="0">
            <span *ngIf="option.translated" skeletonLoader [translationKey]="option.key">
                {{option.label | async}}
            </span>

            <span *ngIf="!option.translated">
                {{option.label}}
            </span>
        </button>
        <button *ngIf="!option.tooltip" type="button" 
        [disabled]="(option.disableButton ? option.disableButton : null) || loading"
        (click)="TAP_select(option.value)" 
        [attr.aria-label]="option.label" 
        role="radio" 
        [attr.aria-checked]="option.value === this.value" 
        tabindex="0">    
            <span *ngIf="option.translated" skeletonLoader [translationKey]="option.key">
                {{option.label | async}}
            </span>

            <span *ngIf="!option.translated">
                {{option.label}}
            </span>
        </button>
    </li>
</ul>
